@if (price$ | async; as price) {
  {{ price }}
}
